import type { MouseEventHandler } from "react";

import AppleIcon from "shared/assets/svgs/apple.svg?react";
import GoogleIcon from "shared/assets/svgs/google-icon.svg?react";
import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
  provider: "apple" | "google";
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const ProviderTile = (props: Props) => {
  const { className, provider, onClick } = props;

  return (
    <button
      type="button"
      aria-label={
        provider === "apple"
          ? "Connect Apple account"
          : "Connect Google account"
      }
      onClick={onClick}
      className={cn(
        "bg-dark-grey flex size-12 shrink-0 cursor-pointer items-center justify-center rounded-xl outline-hidden transition-[filter] hover:brightness-125 active:brightness-125",
        className
      )}
    >
      {provider === "apple" ? (
        <AppleIcon className="size-6 [&_path]:fill-white" />
      ) : (
        <GoogleIcon className="size-6" />
      )}
    </button>
  );
};
